import { create } from "zustand";
import { persist } from "zustand/middleware";

interface IUserSlice {
  user: any;
  isManagerOrWatcher: boolean;
  setUser: (user: any) => void;
  setIsManagerOrWatcher: (value: boolean) => void;
  resetUserData: () => void;
}

const initialUserState = {
  isManagerOrWatcher: false,
  user: null,
};

export const useUserStore = create<IUserSlice>()(
  persist(
    set => ({
      ...initialUserState,

      resetUserData: () => set({ ...initialUserState }),

      setIsManagerOrWatcher: value => set({ isManagerOrWatcher: value }),

      setUser: user => set({ user }),
    }),
    {
      name: "user-store", // ключ в localStorage
    },
  ),
);
